import type { FunctionComponent } from 'react';
import {
  BodyText,
  BodyTextExtraPadding,
  DataProviderContainer,
  StyledDataProviderOutboundLink,
  StyledOutboundLink,
} from '../styles';
import styled from 'styled-components';
import { OutboundLink } from '../../../../app-kit/components/OutboundLink/OutboundLink';
import { paletteHelper } from '@property.com.au/ui-kit';
import archistarSvg from '../../../../assets/archistar.svg';

const Spacer = () => {
  return <>&nbsp;</>;
};

const DisclaimerLink = styled(OutboundLink)`
  color: ${paletteHelper('textSecondary')};

  &:hover,
  &:focus {
    color: ${paletteHelper('textPrimary')};
  }
`;

export const GovernmentDataV2DisclaimerContent: FunctionComponent = () => {
  return (
    <>
      <BodyText>
        This information below has been aggregated from third party data sources and may contain
        inaccuracies. You should always consult the relevant government body or original source to
        verify information before relying on it.
      </BodyText>
      <Spacer />
      <BodyText>
        &copy; Geoscape Australia. See Copyright Notices and Disclaimer{' '}
        <StyledOutboundLink
          href="https://geoscape.com.au/legal/data-copyright-and-disclaimer/"
          outboundLinkType="government-data-disclaimer"
          variant="inline"
          rel="noopener noreferrer"
        >
          here
        </StyledOutboundLink>
        .
      </BodyText>
      <Spacer />
      <BodyText>
        The State of Victoria owns the copyright in the Property Sales Data and reproduction of that
        data in any way without the consent of the State of Victoria will constitute a breach of the
        Copyright Act 1968 (Cth). The State of Victoria does not warrant the accuracy or
        completeness of the Property Sales Data and any person using or relying upon such
        information does so on the basis that the State of Victoria accepts no responsibility or
        liability whatsoever for any errors, faults, defects or omissions in the information
        supplied.
      </BodyText>
      <BodyTextExtraPadding>
        Contains property sales information provided under licence from the Valuer General New South
        Wales.
      </BodyTextExtraPadding>
      <BodyTextExtraPadding>
        Based on information provided under licence by the Department of Lands and Planning,
        Northern Territory of Australia.
      </BodyTextExtraPadding>
      <BodyTextExtraPadding>
        Based on or contains data provided by the State of Queensland (Department of Resources)
        2024. In consideration of the State permitting use of this data you acknowledge and agree
        that the State gives no warranty in relation to the data (including accuracy, reliability,
        completeness, currency or suitability) and accepts no liability (including without
        limitation, liability in negligence) for any loss, damage or costs (including consequential
        damage) relating to any use of the data. Data must not be used for direct marketing or be
        used in breach of the privacy laws; more information at{' '}
        <DisclaimerLink
          outboundLinkType="property-data-code-of-conduct-qld"
          href="https://www.propertydatacodeofconduct.com.au"
          variant="inline"
        >
          www.propertydatacodeofconduct.com.au
        </DisclaimerLink>
      </BodyTextExtraPadding>
      <BodyTextExtraPadding>
        This information is based on data supplied by the South Australian Government and is
        published by permission. The South Australian Government does not accept any responsibility
        for the accuracy, completeness or suitability for any purpose of the published information
        or underlying data.
      </BodyTextExtraPadding>
      <BodyTextExtraPadding>
        This product incorporates data the copyright ownership of which is vested in the Crown in
        Right of Tasmania. The data has been used in the product with the permission of the Crown in
        Right of Tasmania. The Crown in Right of Tasmania and its employees and agents: (a) give no
        warranty regarding the data’s accuracy, completeness, currency or suitability for any
        particular purpose; and (b) do not accept liability howsoever arising, including but not
        limited to negligence, for any loss resulting from the use of or reliance upon the data.
        Base data with the LIST &copy; Crown in Right of Tasmania{' '}
        <DisclaimerLink
          href="https://www.thelist.tas.gov.au"
          outboundLinkType="the-list-tas-outbound-link"
          variant="inline"
        >
          www.thelist.tas.gov.au
        </DisclaimerLink>
      </BodyTextExtraPadding>
      <BodyTextExtraPadding>
        Information contained within this product includes location information data licensed from
        Western Australian Land Information Authority (WALIA) trading as Landgate. Copyright in the
        location information data remains with WALIA. WALIA does not warrant the accuracy or
        completeness of the location information data or its suitability for any particular purpose.
      </BodyTextExtraPadding>
      <BodyTextExtraPadding>
        The Territory Data is the property of the Australian Capital Territory. No part of it may in
        any form or by any means (electronic, mechanical, microcopying, photocopying, recording or
        otherwise) be reproduced, stored in a retrieval system or transmitted without prior written
        permission. Enquiries should be directed to: Manager, Customer Services, Environment and
        Planning Directorate, GPO Box 158 CANBERRA ACT 2601.
      </BodyTextExtraPadding>{' '}
      <DataProviderContainer>
        <BodyText>
          Powered by&nbsp;
          <StyledDataProviderOutboundLink
            href="https://www.archistar.ai/"
            outboundLinkType="government-data-disclaimer-archistar-link"
            variant="inline"
            rel="noopener noreferrer"
          >
            Archistar
          </StyledDataProviderOutboundLink>
        </BodyText>
        <img alt="" width="24" height="24" src={archistarSvg} />
      </DataProviderContainer>
    </>
  );
};
